import gql from 'graphql-tag';
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsEmployeeScans from "graphql/fields/FieldsEmployeeScans";
import HelperGraphql from 'utils/helper-graphql'
import FieldsJobtitle from 'graphql/fields/FieldsJobtitle'

const fields = {
	'guid': '[String!]'
};

export default gql(`
	query employees( ${ HelperGraphql.createFields( { ...fields, ...{ 'scanned_in_at': 'String' } } ) } )  {
		employees( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsEmployee}
		    ics_url
		    bookings_may_overlap
			transport_kind
		
			team {
				guid
			}
			
			table {
				guid
			}
			
			lunch_option {
				guid
			}
			
			language {
				guid
				code
			}
			
			department {
				guid
			}
			
			jobtitle {
				${FieldsJobtitle}
			}
			
			scans( scanned_in_at: $scanned_in_at ) {
				${FieldsEmployeeScans}
			}
		}
	}
`);

